export class AuswahlDDB {
  public bezeichnung: string = '';
  public id: bigint | null = 0n;

  constructor(i: bigint, b: string) {
    this.id = i;
    this.bezeichnung = b;
  }
}
